import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.ai_extraction_test');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-ai_extraction_test',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.ai_extraction_test/view.scss */
:host {
  display: block;
  height: 100%;
  --ink:#14212b;
  --muted:#657681;
  --line:#dde4e8;
  --strong:#c8d3d9;
  --navy:#12344d;
  --blue:#176b87;
  --canvas:#f5f7f8;
}

* {
  box-sizing: border-box;
}

button, select, textarea {
  font: inherit;
}

button:focus-visible, a:focus-visible, select:focus-visible, textarea:focus-visible {
  outline: 3px solid rgba(23, 107, 135, 0.24);
  outline-offset: 1px;
}

.experiment-page {
  display: grid;
  grid-template-columns: 236px minmax(0, 1fr);
  min-height: 100%;
  color: var(--ink);
  background: var(--canvas);
  font-family: SUIT, Arial, sans-serif;
}

.review-sidebar {
  position: sticky;
  top: 0;
  display: flex;
  flex-direction: column;
  height: 100vh;
  padding: 20px 14px 16px;
  color: #dce7ed;
  border-right: 1px solid #092538;
  background: #102d40;
}

.review-brand {
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 0 8px 22px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.brand-symbol {
  display: grid;
  place-items: center;
  width: 34px;
  height: 34px;
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.22);
  background: #1d536b;
}

.review-brand strong, .review-brand small {
  display: block;
}

.review-brand strong {
  font-size: 15px;
}

.review-brand small {
  margin-top: 2px;
  color: #98b3c2;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.11em;
}

.review-sidebar nav {
  flex: 1;
  padding-top: 18px;
}

.review-sidebar nav a {
  display: flex;
  align-items: center;
  gap: 11px;
  min-height: 40px;
  margin: 2px 0;
  padding: 0 11px;
  color: #b9ccd6;
  border: 1px solid transparent;
  border-radius: 5px;
  text-decoration: none;
}

.review-sidebar nav a i {
  width: 17px;
  color: #86a4b4;
  text-align: center;
}

.review-sidebar nav a:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.055);
}

.review-sidebar nav a.active {
  color: #fff;
  border-color: rgba(115, 186, 211, 0.22);
  background: #19445b;
}

.review-sidebar-footer {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 9px 0;
  color: #8eabb9;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 13px;
}

.review-sidebar-footer span {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #d3a84c;
}

.experiment-workspace {
  min-width: 0;
  padding: 28px;
}

.hero, .paper-card, .section-head, .usage-row, .evidence-summary, .analysis-card-head, .context-meta, .panel-title, .review-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 22px;
}

.hero {
  margin-bottom: 18px;
  padding: 2px 0 18px;
  border-bottom: 1px solid var(--line);
}

.hero h1 {
  margin: 5px 0;
  font-size: 27px;
  letter-spacing: -0.02em;
}

.hero p, .paper-card p {
  margin: 0;
  color: var(--muted);
}

.eyebrow {
  color: var(--blue);
  font-size: 15px;
  font-weight: 800;
  letter-spacing: 0.11em;
}

.hero-actions {
  display: flex;
  gap: 8px;
}

button, a.secondary {
  padding: 10px 14px;
  color: #fff;
  border: 1px solid var(--navy);
  border-radius: 5px;
  background: var(--navy);
  font-weight: 700;
  text-decoration: none;
  cursor: pointer;
}

button:disabled {
  cursor: wait;
  opacity: 0.55;
}

a.secondary {
  color: #34454f;
  border-color: var(--strong);
  background: #fff;
}

.experiment-tabs {
  display: flex;
  width: fit-content;
  margin-bottom: 18px;
  border: 1px solid var(--strong);
  border-radius: 5px;
  overflow: hidden;
  background: #eef2f4;
}

.experiment-tabs button {
  padding: 9px 15px;
  color: #5d6b74;
  border: 0;
  border-right: 1px solid var(--strong);
  border-radius: 0;
  background: transparent;
}

.experiment-tabs button:last-child {
  border-right: 0;
}

.experiment-tabs button.active {
  color: var(--navy);
  box-shadow: inset 0 -2px var(--blue);
  background: #fff;
}

.notice, .loading {
  margin: 10px 0;
  padding: 12px 14px;
  color: #285c70;
  border: 1px solid #bcd4de;
  border-radius: 4px;
  background: #edf6f8;
}

.notice.danger {
  color: #93413b;
  border-color: #e1b9b5;
  background: #fbeeed;
}

.paper-card, .usage, .evidence-section, .analysis-section, .cause-summary {
  margin-top: 16px;
  padding: 19px;
  border: 1px solid var(--line);
  border-radius: 7px;
  background: #fff;
}

.paper-card h2 {
  max-width: 850px;
  margin: 9px 0;
  font-size: 21px;
}

.paper-card dl {
  min-width: 280px;
  margin: 0;
}

.paper-card dl div {
  display: grid;
  grid-template-columns: 80px 1fr;
  gap: 12px;
  padding: 5px 0;
}

dt {
  color: var(--muted);
}

dd {
  margin: 0;
  overflow-wrap: anywhere;
  font-weight: 700;
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(8, minmax(100px, 1fr));
  gap: 0;
  margin-top: 16px;
  border: 1px solid var(--line);
  border-radius: 7px;
  overflow: hidden;
  background: #fff;
}

.summary-grid.analysis-summary {
  grid-template-columns: repeat(6, minmax(120px, 1fr));
}

.summary-grid article {
  padding: 14px;
  border-right: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
  background: #fff;
}

.summary-grid span {
  display: block;
  color: var(--muted);
  font-size: 15px;
}

.summary-grid strong {
  display: block;
  margin-top: 7px;
  font-size: 23px;
}

.usage h3, .section-head h3 {
  margin: 0 0 10px;
}

.usage-row {
  justify-content: flex-start;
  flex-wrap: wrap;
  color: var(--muted);
}

.usage-row span {
  padding-right: 18px;
}

.cause-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(150px, 1fr));
  gap: 1px;
  border: 1px solid var(--line);
  background: var(--line);
}

.cause-grid article {
  position: relative;
  padding: 14px;
  background: #fff;
}

.cause-grid span {
  display: block;
  min-height: 30px;
  color: var(--muted);
  font-size: 16px;
}

.cause-grid strong {
  display: inline-block;
  margin-top: 5px;
  font-size: 23px;
}

.cause-grid em {
  float: right;
  margin-top: 12px;
  color: var(--blue);
  font-size: 16px;
  font-style: normal;
  font-weight: 800;
}

.cause-dominant {
  margin: 13px 0 0;
}

.category-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 13px;
}

.category-list span {
  padding: 5px 8px;
  color: #52616b;
  border: 1px solid var(--line);
  background: #f5f7f8;
  font-size: 15px;
}

.filter-head {
  align-items: flex-end;
}

.filters {
  display: flex;
  gap: 9px;
}

.filters label, .note-field {
  display: grid;
  gap: 5px;
  color: var(--muted);
  font-size: 15px;
}

select, textarea {
  color: var(--ink);
  border: 1px solid var(--strong);
  border-radius: 4px;
  background: #fff;
}

select {
  min-width: 160px;
  padding: 8px 10px;
}

textarea {
  width: 100%;
  padding: 10px;
  resize: vertical;
  line-height: 1.5;
}

.analysis-section, .evidence-section {
  margin-bottom: 30px;
}

.section-head {
  margin-bottom: 14px;
}

.analysis-card, .evidence-card {
  margin-top: 8px;
  border: 1px solid var(--line);
  border-radius: 6px;
  overflow: hidden;
}

.analysis-card-head, .evidence-summary {
  width: 100%;
  padding: 14px;
  color: var(--ink);
  border: 0;
  border-radius: 0;
  background: #fff;
  text-align: left;
}

.analysis-card-head:hover, .evidence-summary:hover {
  background: #f8fafb;
}

.analysis-card-head h4, .evidence-summary h4 {
  margin: 6px 0;
  font-size: 17px;
}

.analysis-card-head p, .evidence-summary p {
  margin: 0;
  color: var(--muted);
  font-size: 16px;
  font-weight: 500;
}

.head-meta {
  display: grid;
  gap: 5px;
  justify-items: end;
  color: var(--muted);
  font-size: 15px;
}

code {
  color: var(--blue);
  overflow-wrap: anywhere;
}

.badges {
  display: flex;
  gap: 6px;
}

.status {
  display: inline-flex;
  padding: 4px 7px;
  border: 1px solid transparent;
  border-radius: 3px;
  font-size: 15px;
  font-weight: 800;
  white-space: nowrap;
}

.status.ok, .comparison-flags span.ok {
  color: #246a51;
  border-color: #bad8cb;
  background: #eaf5f0;
}

.status.warn {
  color: #8b5d12;
  border-color: #e7d19f;
  background: #fbf3df;
}

.status.danger, .comparison-flags span.danger {
  color: #8e3d38;
  border-color: #e5beb9;
  background: #fbeeed;
}

.status.neutral {
  color: #596973;
  border-color: #d4dde1;
  background: #f2f5f6;
}

.evidence-detail, .analysis-detail {
  padding: 17px;
  border-top: 1px solid var(--line);
  background: #fafbfb;
}

.detail-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1px;
  border: 1px solid var(--line);
  background: var(--line);
}

.detail-grid div {
  padding: 10px;
  background: #fff;
}

.detail-grid span {
  display: block;
  color: var(--muted);
  font-size: 15px;
}

.detail-grid b {
  display: block;
  margin-top: 4px;
  overflow-wrap: anywhere;
  font-size: 16px;
}

.context-section h5, .manual-review h5 {
  margin: 0 0 9px;
  font-size: 17px;
}

.context-unit {
  margin-top: 10px;
  border: 1px solid var(--line);
  border-radius: 5px;
  overflow: hidden;
  background: #fff;
}

.context-meta {
  padding: 9px 12px;
  border-bottom: 1px solid var(--line);
  color: var(--muted);
  font-size: 15px;
}

.context-block {
  padding: 11px 13px;
  border-bottom: 1px solid #edf1f3;
}

.context-block:last-child {
  border-bottom: 0;
}

.context-block b {
  color: var(--muted);
  font-size: 15px;
}

.context-block p {
  margin: 5px 0 0;
  line-height: 1.6;
  white-space: pre-wrap;
}

.context-block.muted {
  color: #687780;
  background: #f8f9fa;
}

.context-block.target {
  border-left: 3px solid var(--blue);
  background: #eff6f8;
}

.side-by-side {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 14px;
  margin-top: 16px;
}

.evidence-panel {
  min-width: 0;
  padding: 16px;
  border: 1px solid var(--line);
  border-radius: 6px;
  background: #fff;
}

.evidence-panel.human {
  border-top: 3px solid #287458;
}

.evidence-panel.ai {
  border-top: 3px solid var(--blue);
}

.panel-title span {
  font-size: 15px;
  font-weight: 900;
  letter-spacing: 0.08em;
}

.evidence-panel h5 {
  margin: 13px 0 9px;
  font-size: 16px;
}

.source-note {
  display: inline-flex;
  margin-top: 10px;
  padding: 4px 7px;
  color: #8b5d12;
  border: 1px solid #e7d19f;
  background: #fbf3df;
  font-size: 14px;
  font-weight: 800;
}

.evidence-fields {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1px;
  margin: 0;
  border: 1px solid var(--line);
  background: var(--line);
}

.evidence-fields div {
  min-width: 0;
  padding: 8px;
  background: #f9fafb;
}

.evidence-fields dt {
  font-size: 14px;
}

.evidence-fields dd {
  margin-top: 3px;
  font-size: 15px;
}

blockquote {
  margin: 14px 0;
  padding: 13px 15px;
  border-left: 3px solid var(--blue);
  background: #f4f8fa;
  font-family: Georgia, serif;
  line-height: 1.62;
  white-space: pre-wrap;
}

.provenance {
  color: #52616b;
}

.span-list {
  margin-top: 10px;
}

.span-list > strong {
  color: var(--muted);
  font-size: 14px;
  text-transform: uppercase;
}

.span-list blockquote {
  margin: 6px 0;
  padding: 8px 10px;
  font-size: 15px;
}

.human-comment {
  padding: 11px;
  color: #315c47;
  border: 1px solid #c5ddcf;
  background: #eef8f2;
}

.human-comment p {
  margin: 5px 0 0;
  line-height: 1.5;
}

.comparison-flags {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.comparison-flags span {
  padding: 4px 7px;
  border-radius: 3px;
  font-size: 14px;
  font-weight: 800;
}

.issues {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
  margin-top: 10px;
}

.issues span {
  padding: 4px 7px;
  color: #8e3d38;
  border: 1px solid #e5beb9;
  background: #fbeeed;
  font-size: 15px;
}

.validator-status {
  margin: 10px 0 0;
  color: var(--muted);
  font-size: 15px;
}

.manual-review {
  margin-top: 16px;
  padding: 16px;
  border: 1px solid #c8d9df;
  border-radius: 6px;
  background: #f2f7f8;
}

.manual-review > div:first-child p {
  margin: 4px 0 12px;
  color: var(--muted);
  font-size: 15px;
}

.review-options {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.review-options label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 9px;
  color: #34454f;
  border: 1px solid var(--strong);
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
  font-size: 15px;
}

.review-options input {
  accent-color: var(--blue);
}

.note-field {
  margin-top: 12px;
}

.review-actions {
  justify-content: flex-start;
  margin-top: 10px;
}

.review-actions span {
  color: #246a51;
  font-size: 15px;
  font-weight: 700;
}

.review-actions span.error-text {
  color: #8e3d38;
}

.empty {
  padding: 32px;
  color: var(--muted);
  border: 1px dashed #c2cdd3;
  border-radius: 5px;
  text-align: center;
}

.empty.compact {
  padding: 16px;
}

@media (max-width: 1200px) {
  .summary-grid {
    grid-template-columns: repeat(4, 1fr);
  }
  .summary-grid.analysis-summary {
    grid-template-columns: repeat(3, 1fr);
  }
  .detail-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 940px) {
  .experiment-page {
    display: block;
  }
  .review-sidebar {
    position: static;
    width: 100%;
    height: auto;
  }
  .review-sidebar nav {
    display: flex;
    flex-wrap: wrap;
  }
  .review-sidebar nav a {
    width: auto;
  }
  .review-sidebar-footer {
    display: none;
  }
  .side-by-side {
    grid-template-columns: 1fr;
  }
  .cause-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .filter-head {
    align-items: flex-start;
    flex-direction: column;
  }
}
@media (max-width: 720px) {
  .experiment-workspace {
    padding: 18px 12px;
  }
  .review-sidebar {
    padding: 14px 10px;
  }
  .review-sidebar nav a {
    min-height: 34px;
    padding: 0 9px;
  }
  .review-sidebar nav a span {
    display: none;
  }
  .hero, .paper-card, .evidence-summary, .analysis-card-head {
    align-items: flex-start;
    flex-direction: column;
  }
  .summary-grid, .summary-grid.analysis-summary {
    grid-template-columns: repeat(2, 1fr);
  }
  .detail-grid, .evidence-fields {
    grid-template-columns: 1fr;
  }
  .filters {
    width: 100%;
    flex-direction: column;
  }
  .filters select {
    width: 100%;
  }
  .cause-grid {
    grid-template-columns: 1fr;
  }
  .experiment-tabs {
    width: 100%;
  }
  .experiment-tabs button {
    flex: 1;
  }
}`],
})
export class PageAi_extraction_testComponent implements OnInit {
    public loading: boolean = true;
    public error: string = "";
    public data: any = {};
    public expanded: string = "";
    public activeTab: string = "analysis";

    public analysisLoading: boolean = true;
    public analysisError: string = "";
    public analysisData: any = {};
    public analysisExpanded: string = "";
    public groupFilter: string = "all";
    public errorFilter: string = "all";
    public validatorFilter: string = "all";
    private reviewStorageKey: string =
        "reviewops.aiExtractionReview.unscoped.v1";

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async load() {
        this.loading = true;
        this.analysisLoading = true;
        this.error = "";
        this.analysisError = "";
        await this.service.render();

        const resultResponse = await wiz.call("result");
        if (resultResponse.code === 200) {
            this.data = resultResponse.data || {};
            const paperId = this.data?.paper?.pmcid || this.data?.paper?.paper_id;
            if (paperId) {
                this.reviewStorageKey = `reviewops.aiExtractionReview.${paperId}.v1`;
            }
        } else {
            this.error = resultResponse.data?.message || "실험 결과를 불러오지 못했습니다.";
        }
        this.loading = false;

        const analysisResponse = await wiz.call("analysis");
        if (analysisResponse.code === 200) {
            this.analysisData = analysisResponse.data || {};
            this.prepareAnalysisCases();
        } else {
            this.analysisError = analysisResponse.data?.message || "분석 결과를 불러오지 못했습니다.";
        }
        this.analysisLoading = false;
        await this.service.render();
    }

    public prepareAnalysisCases() {
        const localReviews = this.readLocalReviews();
        for (const row of (this.analysisData?.cases || [])) {
            if (Object.prototype.hasOwnProperty.call(localReviews, row.row_id)) {
                row.review = localReviews[row.row_id] || {};
            }
            row.draftClassifications = [...(row?.review?.classifications || [])];
            row.draftNote = row?.review?.note || "";
            row.saving = false;
            row.saveTimer = null;
            row.saveMessage = row?.review?.reviewed_at
                ? "이 브라우저에 저장된 검토를 불러왔습니다."
                : "선택하거나 메모를 입력하면 자동 저장됩니다.";
        }
        this.rebuildReviewSummary();
    }

    private readLocalReviews(): any {
        try {
            const raw = localStorage.getItem(this.reviewStorageKey);
            const parsed = raw ? JSON.parse(raw) : {};
            return parsed && typeof parsed === "object" ? parsed : {};
        } catch (_) {
            return {};
        }
    }

    private rebuildReviewSummary() {
        const cases = this.analysisData?.cases || [];
        const reviewed = cases.filter((row: any) => {
            const values = row?.review?.classifications || [];
            return values.length > 0 || !!row?.review?.note;
        });
        const reviewedCount = reviewed.length;
        const ratio = (count: number) => reviewedCount
            ? Number((count / reviewedCount).toFixed(4))
            : 0;
        const categoryStats = (this.analysisData?.review_options || []).map(
            (option: any) => {
                const count = reviewed.filter((row: any) =>
                    (row?.review?.classifications || []).includes(option.value)
                ).length;
                return {
                    value: option.value,
                    label: option.label,
                    count,
                    ratio: ratio(count),
                };
            }
        );
        const causeGroups: any[] = [
            {
                value: "prompt_semantic_interpretation",
                categories: [
                    "missed_evidence",
                    "unsupported_extraction",
                    "wrong_relationship_type",
                    "wrong_numeric_interpretation",
                    "taxonomy_gap",
                    "other",
                ],
            },
            {
                value: "pair_direction",
                categories: ["wrong_allergen_pair", "wrong_direction"],
            },
            {
                value: "evidence_granularity",
                categories: [
                    "evidence_granularity_mismatch",
                    "duplicate_over_splitting",
                ],
            },
            {
                value: "provenance",
                categories: ["provenance_citation_error"],
            },
        ];
        const causeStats = causeGroups.map((group: any) => {
            const count = reviewed.filter((row: any) =>
                (row?.review?.classifications || []).some(
                    (value: string) => group.categories.includes(value)
                )
            ).length;
            return { value: group.value, count, ratio: ratio(count) };
        });
        const dominant = causeStats.reduce(
            (current: any, item: any) =>
                item.count > (current?.count || 0) ? item : current,
            null
        );
        this.analysisData.review_summary = {
            total_cases: cases.length,
            reviewed_cases: reviewedCount,
            remaining_cases: cases.length - reviewedCount,
            completion_ratio: cases.length
                ? Number((reviewedCount / cases.length).toFixed(4))
                : 0,
            category_stats: categoryStats,
            cause_stats: causeStats,
            dominant_cause: dominant?.count ? dominant.value : null,
        };
    }

    public async selectTab(tab: string) {
        this.activeTab = tab;
        await this.service.render();
    }

    public async toggle(evidenceId: string) {
        this.expanded = this.expanded === evidenceId ? "" : evidenceId;
        await this.service.render();
    }

    public async toggleAnalysis(rowId: string) {
        this.analysisExpanded = this.analysisExpanded === rowId ? "" : rowId;
        await this.service.render();
    }

    public async setGroupFilter(event: any) {
        this.groupFilter = event?.target?.value || "all";
        await this.service.render();
    }

    public async setErrorFilter(event: any) {
        this.errorFilter = event?.target?.value || "all";
        await this.service.render();
    }

    public async setValidatorFilter(event: any) {
        this.validatorFilter = event?.target?.value || "all";
        await this.service.render();
    }

    public visibleCases(): any[] {
        return (this.analysisData?.cases || []).filter((row: any) => {
            const groupMatches = this.groupFilter === "all"
                || row.comparison_group === this.groupFilter;
            const classifications = row?.draftClassifications
                || row?.review?.classifications
                || [];
            const errorMatches = this.errorFilter === "all"
                || classifications.includes(this.errorFilter);
            const validatorStatus = row?.validator?.status || "no_ai";
            const validatorMatches = this.validatorFilter === "all"
                || validatorStatus === this.validatorFilter;
            return groupMatches && errorMatches && validatorMatches;
        });
    }

    public selected(row: any, value: string): boolean {
        return (row?.draftClassifications || []).includes(value);
    }

    public async toggleClassification(row: any, value: string, event: any) {
        const checked = !!event?.target?.checked;
        let values = [...(row?.draftClassifications || [])];
        if (checked) {
            if (value === "correct") {
                values = ["correct"];
            } else {
                values = values.filter((item: string) => item !== "correct");
                if (!values.includes(value)) values.push(value);
            }
        } else {
            values = values.filter((item: string) => item !== value);
        }
        row.draftClassifications = values;
        await this.scheduleReviewSave(row, 0);
    }

    public async updateNote(row: any, event: any) {
        row.draftNote = event?.target?.value || "";
        await this.scheduleReviewSave(row, 700);
    }

    public async flushReview(row: any) {
        await this.scheduleReviewSave(row, 0);
    }

    public async scheduleReviewSave(row: any, delay: number) {
        if (row.saveTimer) {
            clearTimeout(row.saveTimer);
            row.saveTimer = null;
        }
        row.saveMessage = delay > 0
            ? "자동 저장 대기 중…"
            : "자동 저장 중…";
        await this.service.render();
        row.saveTimer = setTimeout(() => {
            row.saveTimer = null;
            void this.saveReview(row);
        }, delay);
    }

    public async saveReview(row: any) {
        row.saving = true;
        row.saveMessage = "자동 저장 중…";
        await this.service.render();
        try {
            const reviews = this.readLocalReviews();
            const saved = {
                row_id: row.row_id,
                classifications: [...(row.draftClassifications || [])],
                note: row.draftNote || "",
                reviewed_at: new Date().toISOString(),
                review_source: "browser_local_storage",
            };
            reviews[row.row_id] = saved;
            localStorage.setItem(this.reviewStorageKey, JSON.stringify(reviews));
            row.review = saved;
            this.rebuildReviewSummary();
            row.saveMessage = "이 브라우저에 자동 저장됨";
        } catch (_) {
            row.saveMessage = "자동 저장 실패: 브라우저 저장소를 사용할 수 없습니다.";
        }
        row.saving = false;
        await this.service.render();
    }

    public statusLabel(value: string): string {
        const labels: any = {
            completed: "자료 준비 완료",
            partial: "부분 완료",
            blocked: "이용 불가",
            preflight_only: "자료 확인 중",
            not_run: "준비 전",
            valid: "형식 확인",
            invalid: "형식 오류",
            needs_review: "추가 확인 필요",
            exact_match: "정확 일치",
            semantically_equivalent: "의미상 일치",
            field_mismatch: "항목 불일치",
            matched: "일치",
            human_only: "기준 자료에만 있음",
            ai_only: "자동 정리에만 있음",
            not_compared: "비교 전",
        };
        return labels[value] || "상태 확인 필요";
    }

    public statusClass(value: string): string {
        if (["completed", "valid", "exact_match", "semantically_equivalent", "matched"].includes(value)) return "ok";
        if (["blocked", "field_mismatch", "invalid"].includes(value)) return "danger";
        if (["partial", "needs_review", "ai_only", "human_only"].includes(value)) return "warn";
        return "neutral";
    }

    public pair(item: any): string {
        return [item?.source_allergen_raw, item?.target_allergen_raw].filter(Boolean).join(" ↔ ") || "관계 알레르겐 미확인";
    }

    public components(item: any): string {
        const values = [
            item?.source_component_raw,
            item?.target_component_raw,
            item?.source_protein_family_raw,
            item?.target_protein_family_raw,
        ].filter((value: string, index: number, array: string[]) => value && array.indexOf(value) === index);
        return values.length ? values.join(", ") : "—";
    }

    public rate(item: any): string {
        if (item?.rate_value !== null && item?.rate_value !== undefined) {
            const prefix: any = {
                greater_than: ">",
                greater_than_or_equal: "≥",
                less_than: "<",
                less_than_or_equal: "≤",
                up_to: "최대 ",
            };
            return (prefix[item.rate_operator] || "") + item.rate_value + (item.rate_unit || "");
        }
        if (item?.rate_value_min !== null && item?.rate_value_min !== undefined) {
            return item.rate_value_min + "–" + item.rate_value_max + (item.rate_unit || "");
        }
        return item?.rate_text_raw || "—";
    }

    public issues(item: any): string[] {
        const check = item?.experiment_validation || {};
        const values = [...(check.validation_errors || []), ...(check.semantic_findings || [])];
        if (check.denominator_missing) values.push("denominator missing");
        if (check.unsupported_inference) values.push("unsupported inference");
        return values;
    }

    public validatorIssues(row: any): string[] {
        const validator = row?.validator || {};
        const values = [
            ...(validator.hard_invalid_findings || []),
            ...(validator.needs_review_findings || []),
            ...(validator.base_validator_findings || []),
        ];
        if (validator.unsupported_inference) values.push("unsupported inference");
        return values.filter((value: string, index: number, array: string[]) => array.indexOf(value) === index);
    }

    public comparisonFlags(row: any): any[] {
        const comparison = row?.comparison;
        if (!comparison) return [];
        return [
            { label: "알레르겐 관계", ok: comparison.pair_equal },
            { label: "관계 유형", ok: comparison.relationship_equal },
            { label: "방향성", ok: comparison.direction_equal },
            { label: "보고 수치", ok: comparison.numeric_equal },
            { label: "근거 출처", ok: comparison.provenance_equal },
            { label: "원문 연결", ok: comparison.supporting_span_equal },
        ];
    }

    public formatRatio(value: any): string {
        const numeric = Number(value || 0);
        return (numeric * 100).toFixed(1) + "%";
    }

    public causeLabel(value: string): string {
        const labels: any = {
            prompt_semantic_interpretation: "의미 해석",
            pair_direction: "알레르겐 관계·방향성",
            evidence_granularity: "근거 분리 단위",
            provenance: "근거 출처 연결",
        };
        return labels[value] || "기타 확인 사항";
    }

    public reviewOptionLabel(option: any): string {
        const labels: any = {
            correct: "문제 없음",
            missed_evidence: "누락된 근거",
            unsupported_extraction: "원문으로 확인되지 않음",
            wrong_allergen_pair: "알레르겐 관계 오류",
            wrong_direction: "방향성 오류",
            wrong_relationship_type: "관계 유형 오류",
            wrong_numeric_interpretation: "보고 수치 해석 오류",
            provenance_citation_error: "근거 출처 연결 오류",
            evidence_granularity_mismatch: "근거 분리 단위 불일치",
            duplicate_over_splitting: "중복 또는 과도한 분리",
            taxonomy_gap: "분류 기준 확인 필요",
            other: "기타",
        };
        return labels[option?.value] || "기타 확인 사항";
    }

    public issueLabel(value: string): string {
        const labels: any = {
            "denominator missing": "분모 정보 확인 필요",
            denominator_missing: "분모 정보 확인 필요",
            "unsupported inference": "원문으로 확인되지 않는 해석",
            unsupported_inference: "원문으로 확인되지 않는 해석",
            missing_provenance: "근거 출처 확인 필요",
            missing_support_span: "연결된 원문 확인 필요",
            provenance_citation_error: "근거 출처 연결 오류",
            conflicting_numeric_shape: "보고 수치 형식 충돌",
            incomplete_range: "보고 범위 값 확인 필요",
        };
        return labels[value] || "상세 확인 필요";
    }

    public userText(value: any): string {
        if (value === null || value === undefined) return "";
        let text = String(value);
        const replacements: Array<[RegExp, string]> = [
            [/Human[- ]?verified/gi, "확인된"],
            [/Human Review/gi, "기존 검토"],
            [/Accepted/gi, "조회 가능한"],
            [/Evidence drawer/gi, "근거 상세"],
            [/Evidence/gi, "문헌 근거"],
            [/provenance/gi, "근거 출처"],
            [/vector search/gi, "추가 문헌 검색"],
            [/exact lookup/gi, "일치 근거 조회"],
            [/pipeline/gi, "처리 과정"],
            [/candidate/gi, "검토 항목"],
            [/structuring/gi, "정보 정리"],
            [/schema/gi, "자료 형식"],
            [/\bseed\b/gi, "기준 알레르겐"],
            [/\bP\d{2}(?:-\d+)?\b/gi, "내부 처리"],
            [/GPT-[\w.-]+/gi, "자동 정리 도구"],
            [/Terra|Mini/gi, "자동 정리 도구"],
        ];
        for (const [pattern, replacement] of replacements) text = text.replace(pattern, replacement);
        return text;
    }

    public trackEvidence(index: number, item: any) {
        return item.evidence_id || index;
    }

    public trackCase(index: number, item: any) {
        return item.row_id || index;
    }
}

export default PageAi_extraction_testComponent;